import { render } from "./SaveSection.vue?vue&type=template&id=9799abc8&scoped=true"
import script from "./SaveSection.vue?vue&type=script&lang=js"
export * from "./SaveSection.vue?vue&type=script&lang=js"

import "./SaveSection.vue?vue&type=style&index=0&id=9799abc8&scoped=true&lang=css"

import exportComponent from "/Users/permartinson/Documents/GitHub/wpcedit/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9799abc8"]])

export default __exports__